import NextLink from 'next/link'
import PropTypes from 'prop-types'
import HomeIcon from '@mui/icons-material/Home'
import { Breadcrumbs, Link, Stack, SvgIcon, Typography } from '@mui/material'

/**
 * 管理画面の各ページ共通のヘッダー。見出しとパンくずで「今どこにいるか」を示す。
 *
 * breadcrumbs は先頭から順に階層を並べ、末尾が現在地。href を持つ項目はリンクになる。
 * 先頭には常に「管理トップ（/）」のホームアイコンを自動で付ける。
 */
export const PageHeader = (props) => {
  const { title, subtitle, breadcrumbs = [], action } = props

  return (
    <Stack
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      spacing={2}
    >
      <Stack spacing={1}>
        <Breadcrumbs separator="›" aria-label="パンくず">
          <Link
            component={NextLink}
            href="/"
            color="text.secondary"
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <SvgIcon fontSize="small" sx={{ mr: 0.5 }}>
              <HomeIcon />
            </SvgIcon>
            管理トップ
          </Link>
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1
            if (isLast || !crumb.href) {
              return (
                <Typography key={crumb.label} color={isLast ? 'text.primary' : 'text.secondary'} variant="body2">
                  {crumb.label}
                </Typography>
              )
            }
            return (
              <Link key={crumb.label} component={NextLink} href={crumb.href} color="text.secondary" underline="hover">
                {crumb.label}
              </Link>
            )
          })}
        </Breadcrumbs>

        <Typography variant="h4">{title}</Typography>
        {subtitle && (
          <Typography color="text.secondary" variant="body2">
            {subtitle}
          </Typography>
        )}
      </Stack>

      {action}
    </Stack>
  )
}

PageHeader.propTypes = {
  action: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ),
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}
